<template>
    <footer class="main-footer">
        <div class="main-footer-inner">
            <ul class="main-footer-category">
                <li class="main-footer-category-item">
                    <p class="main-footer-category-item-title">テックキャンプについて</p>
                    <ul class="main-footer-cateogry-item-list">
                        <li class="main-footer-category-item-list-item">
                            > オウンドメディア
                        </li>
                    </ul>
                </li>
                <li class="main-footer-category-item">
                    <p class="main-footer-category-item-title">プログラミング教養</p>
                    <ul class="main-footer-cateogry-item-list">
                        <li class="main-footer-category-item-list-item">
                            > 学習内容
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 料金
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 卒業生
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 受講の流れ
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 教室
                        </li>
                    </ul>
                </li>
                <li class="main-footer-category-item">
                    <p class="main-footer-category-item-title">エンジニア転職</p>
                    <ul class="main-footer-cateogry-item-list">
                        <li class="main-footer-category-item-list-item">
                            > 学習内容
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 料金
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 卒業生
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 受講の流れ
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 教室
                        </li>
                    </ul>
                </li>
                <li class="main-footer-category-item">
                    <p class="main-footer-category-item-title">デザイナー転職</p>
                    <ul class="main-footer-cateogry-item-list">
                        <li class="main-footer-category-item-list-item">
                            > 特徴
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 学習内容
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 料金
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 受講の流れ
                        </li>
                    </ul>
                </li>
                <li class="main-footer-category-item">
                    <p class="main-footer-category-item-title">法人サービス</p>
                    <ul class="main-footer-cateogry-item-list">
                        <li class="main-footer-category-item-list-item">
                            > 研修について
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 研修内容
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 研修の導入事例
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 人材紹介について
                        </li>
                        <li class="main-footer-category-item-list-item">
                            > 人材紹介の導入事例
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style scoped>
    .main-footer {
        color: #FFF;
        padding-top: 30px;
        padding-bottom: 30px;
        margin-top:50px;
        background-color: #212121;
    }

    .main-footer-category {
        display: flex;
        margin-top:30px;
    }

    .main-footer-category-item {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
    }

    .main-footer-category-item-title {
        padding-bottom: 10px;
        border-bottom: 1px solid #555;
    }

    ul {
        list-style: none;
        text-align: left;
        padding-inline-start: 0px;
    }

    li {
        text-align: left;
    }

    .main-footer-category-item-list-item {
        color:#fff;
        font-size: .8rem;
        font-weight: 400;
        opacity: .7;
    }

    @media screen and (max-width: 767px){
        .main-footer-category {
        display: flex;
        flex-direction: column;
        margin-top:30px;
    }
    }
</style>